const LOCAL_STORAGE_LOGGED_IN_USER_DATA = "currentUser";
const LOCAL_STORAGE_JWT_TOKEN = "jwtToken";
const CURRENT_ROUTE = "CURRENT_ROUTE";
const IS_SYSTEM_LOCKED = "isSystemLocked";
const SYSTEM_LOCK_REASON = "SYSTEM_LOCK_REASON";
const PREV_ROUTE = "PREV_ROUTE";
const NAVIGATION_HISTORY = "NAVIGATION_HISTORY";
const OCR_LAST_URL = "OCR_LAST_URL";

export {
    LOCAL_STORAGE_LOGGED_IN_USER_DATA,
    LOCAL_STORAGE_JWT_TOKEN,
    CURRENT_ROUTE,
    PREV_ROUTE,
    NAVIGATION_HISTORY,
    OCR_LAST_URL,
    IS_SYSTEM_LOCKED,
    SYSTEM_LOCK_REASON
}
